import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { formatDistanceToNow } from "date-fns";
import { Tag } from "@design-system/Tag/Tag";
import { TeamMemberRow } from "../teamViewConfig";

export const LastActiveCell = ({
    row,
}: CellContext<ViewTableFeatures, TeamMemberRow, any>) => {
    const member = row.original;

    if (member.type === "invite") {
        return (
            <Tag size="sm" color="neutral" outline>
                Invite pending
            </Tag>
        );
    }

    const lastActivity = member.user.lastActivity
        ? formatDistanceToNow(member.user.lastActivity, { addSuffix: true })
        : "-";

    return <>{lastActivity}</>;
};
